// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"styles_contentWrapper__2OsJH","titleWrapper":"styles_titleWrapper__1UUB9","actionBlock":"styles_actionBlock__3uWBK"};